import ShopArticleTaxResourceModel from '../../generated/types/model/resource/ShopArticleTaxResourceModel';

export default class ShopArticleTaxResourceViewModel extends ShopArticleTaxResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
